module.exports = __webpack_public_path__ + "img/speaker-NikaAmashukeli-imgs.a7c7f4b4.png";